<template>
  <div :data-id="panelId" class="flex flex-col gap-5">
    <div :data-id="panelId" class="px-6 pt-5 bg-pure-white">
      <div
        :data-id="panelId"
        class="flex items-center gap-2 mb-4 cursor-pointer"
        @click="$emit('back')"
      >
      <div class="">
        <BlIcon
          :data-id="panelId"
          icon="chevron-left"
          class="w-6 h-6"
          color="grey"
        />
      </div>
      <div class="">
        <BlTextBody2
          :data-id="panelId"
          text="Back to target"
          class="text-slate-800"
        />
      </div>
      </div>

      <div :data-id="panelId" class="mb-4">
        <BlTextBody2
          :data-id="panelId"
          class="text-slate-700"
          :text="`Showing all ${tasks.length} task(s)`"
        />
      </div>

      <div :data-id="panelId" class="flex flex-col gap-4">
        <div
          v-for="task in tasks"
          :key="task.id"
          :data-id="panelId"
          class="flex flex-col gap-1 py-3 border-b border-slate-300"
        >
          <BlTextBody2
            :data-id="panelId"
            class="text-slate-800"
            :text="task.code"
          />
          <BlTextBody2
            :data-id="panelId"
            class="font-medium text-slate-1000"
            :text="task.title"
          />
          <BlTextBody2
            :data-id="panelId"
            class="whitespace-pre-line text-slate-800"
            :text="task.description"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlIcon from "../../BlIcon.vue";
import BlInputButton from "../../BlInputButton.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlTextSubtitle2 from "../../BlTextSubtitle2.vue";

export default {
  name: "TaskDetails",
  props: ["tasks", "panelId"],
  components: {
    BlIcon,
    BlTextBody2,
    BlTextSubtitle2,
    BlInputButton
  },
  mounted() {
    const container = document.querySelector("#panel-details");
    if (container) {
      container.scrollTop = 0;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/repository/databank/TaskDetails.vue